// imports
import merge from 'lodash/merge';
import DEFAULT_CONFIG from 'minsky-kit/js/Config';

export default merge(DEFAULT_CONFIG, {
    globals: GLOBALS, // passed by compiler

    app: {
        readyMessage: [
            '%cMade with %c♥ %cby %cwww.minsky.be',

            'font-weight: normal; font-size: 12px; font-family: Poppins, Helvetica',
            'color: red; font-weight: bold; font-size: 14px',
            'font-weight: normal; font-size: 12px; font-family: Poppins, Helvetica',
            'font-weight: bold; font-size: 12px; font-family: Poppins, Helvetica',
        ],
    },

    mqManager: {
        debounce: 250,

        queries: [
            { name: 'ready', query: '(min-width: 0em)' },
            { name: 'mobileNavInit', query: '(max-width: 53.75em)' },
            { name: 'mobileNavDestroy', query: '(min-width: 53.75em)' },
        ],
    },

    svgSprites: [
        `/themes/custom/${GLOBALS.theme}/assets/sprite.svg`,
    ],

    libManager: {
        libraries: {
            gsap: {
                js: '//cdnjs.cloudflare.com/ajax/libs/gsap/3.6.0/gsap.min.js',
            },
            gsapScrollTrigger: {
                js: '//cdnjs.cloudflare.com/ajax/libs/gsap/3.6.0/ScrollTrigger.min.js',
            },
            gsapScrollTo: {
                js: 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.7.0/ScrollToPlugin.min.js',
            },
        },
    },

    klaroConfig: {
        htmlTexts: true,
        acceptAll: true,
        translations: {
            zz: {
                privacyPolicyUrl: '/cookie-policy',
                acceptAll: Drupal.t('Alles accepteren'),
                acceptSelected: Drupal.t('Accepteer geselecterde'),
                close: Drupal.t('Sluiten'),
                consentModal: {
                    description: Drupal.t('Hier kan je de diensten die wij op deze website willen gebruiken beoordelen en aanpassen. Schakel de diensten naar eigen inzicht in of uit.'),
                    title: Drupal.t('Diensten die we graag willen gebruiken'),
                },
                consentNotice: {
                    changeDescription: Drupal.t('Er waren veranderingen sinds uw laatste bezoek, gelieve je toestemming te hernieuwen.'),
                    description: `${Drupal.t('<h1>Cookies & Privacy</h1> Heey! Mogen wij je een aantal extra diensten aanbieden voor {purposes}? Je kunt jouw toestemming later altijd nog wijzigen of intrekken. Voor meer info, lees onze {privacyPolicy}')}`,
                    learnMore: Drupal.t('Kies je instellingen'),
                    testing: Drupal.t('Testing mode!'),
                },
                contextualConsent: {
                    acceptAlways: Drupal.t('Altijd toestaan'),
                    acceptOnce: Drupal.t('Toestaan'),
                    description: Drupal.t('We zouden graag externe videos van {title} inladen.'),
                },
                decline: Drupal.t('Weigeren'),
                ok: Drupal.t('Accepteer alle'),
                poweredBy: Drupal.t('powered by Klaro'),
                privacyPolicy: {
                    name: Drupal.t('cookie policy'),
                    text: Drupal.t('Voor meer info, lees onze {privacyPolicy}.'),
                },
                purposeItem: {
                    service: Drupal.t('dienst'),
                    services: Drupal.t('diensten'),
                },
                purposes: {
                    advertising: {
                        description: Drupal.t('These services process personal information to show you personalized or interest-based advertisements.'),
                        title: Drupal.t('Advertising'),
                    },
                    functional: {
                        description: Drupal.t('These services are essential for the correct functioning of this website. You cannot disable them here as the service would not work correctly otherwise.'),
                        title: Drupal.t('Service Provision'),
                    },
                    marketing: {
                        description: Drupal.t('These services process personal information to show you relevant content about products, services or topics that you might be interested in.'),
                        title: Drupal.t('Marketing'),
                    },
                    performance: {
                        description: Drupal.t('These services process personal information to optimize the service that this website offers.'),
                        title: Drupal.t('Performance Optimization'),
                    },
                },
                save: Drupal.t('Save'),
                service: {
                    disableAll: {
                        description: Drupal.t('Gebruik deze toggle om alle diensten te aanvaarden of uit te schakelen.'),
                        title: Drupal.t('Selecteer of deselecteer alle diensten.'),
                    },
                    optOut: {
                        description: Drupal.t('This services is loaded by default (but you can opt out)'),
                        title: Drupal.t('(opt-out)'),
                    },
                    purpose: Drupal.t('doeleinde'),
                    purposes: Drupal.t('doeleinden'),
                    required: {
                        description: Drupal.t('This services is always required'),
                        title: Drupal.t('(always required)'),
                    },
                },
            },
        },
        apps: [
            {
                name: Drupal.t('google-analytics'),
                purposes: [Drupal.t('analytics')],
                onAccept: (opts) => {
                    const dataLayer = window.dataLayer || [];
                    for (const k of Object.keys(opts.consents)) {
                        if (opts.consents[k]) {
                            console.log(`klaro-${k}-accepted`);
                            const eventName = `klaro-${k}-accepted`;
                            dataLayer.push({ event: eventName });
                        }
                    }
                },
                vars: {
                    googleAnalytics: 'google-analytics',
                },
            },
            {
                purposes: [Drupal.t('Externe videos')],
                name: 'vimeo',
                description: Drupal.t('Videos van Vimeo bekijken op onze website.'),
            },
            {
                purposes: [Drupal.t('Externe videos')],
                name: 'youtube',
                description: Drupal.t('Videos van Youtube bekijken op onze website.'),
            },
        ],
    },

    cookieConsent: {
        active: false,
        loggedInUsers: false,
        acceptAllButton: true,
        labels: {
            title: Drupal.t('minskyString.cookieConsent.labels.title'),
            description: Drupal.t('minskyString.cookieConsent.labels.description'),
            listTitle: Drupal.t('minskyString.cookieConsent.labels.listTitle'),
            // Button labels based on state and preferences.
            button: {
                // The default button label.
                default: Drupal.t('minskyString.cookieConsent.button.default'),
                // The minimal button label.
                minimal: Drupal.t('minskyString.cookieConsent.button.minimal'),
                // Shown when `acceptAllButton` is set, and no option is selected.
                acceptAll: Drupal.t('minskyString.cookieConsent.button.acceptAll'),
            },
            // ARIA labels to improve accessibility.
            aria: {
                button: Drupal.t('minskyString.cookieConsent.aria.button'),
                tabList: Drupal.t('minskyString.cookieConsent.aria.tabList'),
                tabToggle: Drupal.t('minskyString.cookieConsent.aria.tabToggle'),
            },
        },
        cookies: [
            {
                id: 'functional',
                label: Drupal.t('minskyString.cookieConsent.functionalCookie.label'),
                description: Drupal.t('minskyString.cookieConsent.functionalCookie.description'),
                required: true,
            },
            {
                id: 'marketing',
                label: Drupal.t('minskyString.cookieConsent.marketingCookie.label'),
                description: Drupal.t('minskyString.cookieConsent.marketingCookie.description'),
                checked: false,
            },
            {
                id: 'social',
                label: Drupal.t('minskyString.cookieConsent.socialCookie.label'),
                description: Drupal.t('minskyString.cookieConsent.socialCookie.description'),
                checked: false,
            },
        ],
    },
});
